import { AccredibleOrganizationSettings } from '@accredible-frontend-v2/models';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  organizationSettings$: Observable<AccredibleOrganizationSettings>;

  constructor(private readonly _language: AccredibleLanguageService) {}
}
